import { Component, inject, OnInit, signal, WritableSignal } from '@angular/core';
import { Router } from '@angular/router';

import { AuthenticationService } from '../../services/authentication.service';
import { I18nService } from '../../services/i18n.service';
import { ScrollToTopComponent } from '../scroll-to-top/scrollToTop';
import { NavButtonComponent } from '../nav-button/nav-button';
import { initializeContent } from '../../utilities/global.util';
import { App_Routes } from '../../enums/router.enum';

@Component({
  selector: 'app-data-protection',
  templateUrl: './data-protection.html',
  styleUrls: ['./data-protection.scss'],
  imports: [ScrollToTopComponent, NavButtonComponent],
})
export class DataProtectionComponent implements OnInit {
  private router = inject(Router);
  public i18n = inject(I18nService);
  private auth = inject(AuthenticationService);
  public contentSections: any[] = [];

  ngOnInit(): void {
    this.contentSections = initializeContent();
    if (this.router.url.includes('/us/')) {
      this.showUSCountryPage.set(true);
    }
  }

  showUSCountryPage: WritableSignal<boolean> = signal(this.router.url.includes('/us/'));

  isAuth = signal<boolean>(this.auth.isLoggedIn());

  gotoLogin() {
    if (this.router.url.includes('settings')) {
      this.router.navigate([App_Routes.SETTINGS]);
    } else {
      this.router.navigate([App_Routes.LOGIN]);
    }
  }
}
